import React, { useContext } from 'react'
import { graphql, Link, useStaticQuery } from 'gatsby'
import SlideMenuContext from '../context/SlideMenuContext'
import flatListToHierarchical from '../helpers/menu'
import {
  InstagramLogo,
  PinterestLogo,
  FacebookLogo,
  X,
  CaretRight,
  Plus,
  Minus,
} from 'phosphor-react'

const SlideMenu = ({ children }) => {
  const { open, toggleMenu, openIndex, setOpenIndex } = useContext(
    SlideMenuContext
  )

  const data = useStaticQuery(graphql`
    query {
      hamburgerMenu: wpMenu(name: { eq: "Hamburger Menu" }) {
        id
        menuItems {
          nodes {
            url
            label
            id
            parentId
          }
        }
      }
    }
  `)
  const { hamburgerMenu } = data

  const hamburgerItems = flatListToHierarchical(hamburgerMenu.menuItems.nodes)

  return (
    <div
      className={`overlay bg-white bg-opacity-50 inset-0 fixed w-screen h-screen ${
        open
          ? 'pointer-events-auto opacity-100'
          : 'pointer-events-none opacity-0'
      } transition-all`}
    >
      <div
        className={`relative py-8 w-full max-w-lg h-full overflow-y-scroll bg-white slide-menu inset-0  transition-all ${open &&
          'show'}`}
      >
        <X
          className="top-8 right-8 absolute cursor-pointer close-slide-menu"
          size={24}
          onClick={() => toggleMenu()}
        />
        <Link to="/" className="home-link-image">
          <img
            src="/dm-logo-blue.png"
            className="w-28 mx-auto object-contain transition-all"
            alt="dm-logo"
          />
        </Link>
        <p className="text-center text-lg my-5">
          Phone <a href="tel:817-355-3273">(817)35-LEASE</a>
        </p>
        <div className="w-full justify-items-center border-t">
          {hamburgerItems.map((sectionItem, i) => (
            <ToggleGroup
              sectionItem={sectionItem}
              i={i}
              key={sectionItem.id}
              setOpenIndex={setOpenIndex}
              openIndex={openIndex}
              toggleMenu={toggleMenu}
            />
          ))}
        </div>

        <hr className="mt-20 mb-5" />

        <div className="flex w-full justify-center gap-x-2">
          <a
            href="https://www.facebook.com/dmautoleasing/"
            rel="noreferrer"
            target="_blank"
          >
            <FacebookLogo size={30} color="black" />
          </a>
          <a
            rel="noreferrer"
            target="_blank"
            href="https://www.instagram.com/dmleasing/"
          >
            <InstagramLogo size={30} color="black" />
          </a>

          <a
            rel="noreferrer"
            target="_blank"
            href="https://www.pinterest.com/dmleasing/"
          >
            <PinterestLogo size={30} color="black" />
          </a>
        </div>
      </div>
    </div>
  )
}

const ToggleGroup = ({
  sectionItem,
  setOpenIndex,
  openIndex,
  i,
  toggleMenu,
}) => {
  let hasChildren = sectionItem.children.length
  let icon = hasChildren ? <Plus /> : <CaretRight />
  const active = openIndex === i

  if (active && hasChildren) {
    icon = <Minus />
  }

  if (!hasChildren) {
    return (
      <Link to={sectionItem.url} onClick={() => toggleMenu()}>
        <div className="border-b px-8 py-4 flex justify-between items-center hover:bg-gray-100 transition-all cursor-pointer">
          <span className="text-gray-600 text-lg">{sectionItem.label}</span>
          {icon}
        </div>
      </Link>
    )
  }

  return (
    <div
      className="text-left w-full border-b "
      onClick={() => setOpenIndex(openIndex === i ? null : i)}
      key={sectionItem.id}
    >
      <div className="px-8 py-4 flex justify-between items-center hover:bg-gray-100 transition-all cursor-pointer">
        <span className="text-gray-600 text-lg">{sectionItem.label}</span>
        {icon}
      </div>
      <div
        className={`px-8 pb-4 transition origin-top-right transform ${
          active ? '' : 'hidden h-0'
        } transition-all`}
      >
        {sectionItem.children.map(childItem => (
          <Link
            key={childItem.id}
            className="hover:underline block text-base my-2"
            to={childItem.url}
            onClick={() => toggleMenu()}
          >
            {childItem.label}
          </Link>
        ))}
      </div>
    </div>
  )
}

export default SlideMenu
